"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var React = _interopRequireWildcard(require("react"));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ic_sim(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "1em",
    height: "1em",
    viewBox: "0 0 192 192"
  }, props), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "9c303c45-27b5-4ea0-859f-37628ed2402e",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 66,
    y: 96,
    width: 60,
    height: 60,
    rx: 16,
    ry: 16,
    fill: "none"
  }))), /*#__PURE__*/React.createElement("title", null, "sim-hi"), /*#__PURE__*/React.createElement("g", {
    id: "854b811e-4226-409a-874f-4a6a8876624f",
    "data-name": "sim-hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ab59d4e0-9e80-4158-91ef-8b9e98d5aae2",
    "data-name": "Apps_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "da187548-a1dd-4a1f-88bb-faf7e6c37a81",
    "data-name": "Bill_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "7044d5da-272f-4006-8c21-9a02b8ef29dc",
    "data-name": "Report_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "bddaf0dd-3160-4571-978e-4acc18c2f1e8",
    "data-name": "vodafone_store_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "a525c497-1451-4060-8bde-da628dcf0186",
    "data-name": "Broadband_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "c2d261e8-b58c-4213-902f-8b07b01fb398",
    "data-name": "Business_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "25080011-89bd-477c-aef8-c0690932d7c6",
    "data-name": "Calendar_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "308bcc9f-83bc-4b35-87bd-e10e1fcf5575",
    "data-name": "Camera_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "834a0624-85d4-4082-b8a7-e36ea33a60b0",
    "data-name": "Data_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "5b2c73b3-e4e9-46dd-8982-ce05a44a3854",
    "data-name": "Desktop_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "1153ca10-2111-455f-aa7c-766289f21cf8",
    "data-name": "Document_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "1d0caf4c-a38c-4e8f-b237-5259414e1bcb",
    "data-name": "Edit_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "28fdb114-1e9a-4d2a-b397-ab793c5b059a",
    "data-name": "Enterprise_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "7f419912-6ddd-4a11-852c-1c1a0fb45685",
    "data-name": "Call_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "2144a485-4f37-4658-9c0b-b5042718f088",
    "data-name": "Location_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "df67b41f-401e-4bc6-a102-86d4c4c99adf",
    "data-name": "Mail_new_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "84234a3c-71d8-42f8-bc73-3dd9992564d7",
    "data-name": "Mail_unread_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "9bcec288-ede7-4bd7-a566-9144845f3012",
    "data-name": "Mobile_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "48899fdb-221d-4fdb-b3c7-a0d452477b57",
    "data-name": "Network_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "7a3666b6-3308-49e2-8870-4d76947ce7a1",
    "data-name": "Reports_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "3e007c58-2d78-489b-8cfb-7c2930411a37",
    "data-name": "Roaming_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "fa3bee49-4de4-43c2-bd40-bca573b1a0d0",
    "data-name": "Security_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "7b4ceabd-3f8b-4c63-99c1-6dadbebf5fd0",
    "data-name": "Sim_ic_hi"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M112,16H64A16,16,0,0,0,48,32V160a16,16,0,0,0,16,16h64a16,16,0,0,0,16-16V48Z",
    transform: "translate(0 0)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64,174h64a16,16,0,0,0,16-16v2a16,16,0,0,1-16,16H64a16,16,0,0,1-16-16v-2A16,16,0,0,0,64,174Z",
    transform: "translate(0 0)",
    opacity: 0.06
  }), /*#__PURE__*/React.createElement("rect", {
    x: 66,
    y: 96,
    width: 60,
    height: 60,
    rx: 16,
    ry: 16,
    opacity: 0.06
  }), /*#__PURE__*/React.createElement("rect", {
    id: "ccce3f95-c0ef-4ceb-854f-39124c3498db",
    "data-name": "Bounding Box",
    width: 192,
    height: 192,
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96,51a10,10,0,1,0,10,10A10,10,0,0,0,96,51Zm4.89,12.69a5.24,5.24,0,0,1-1.43,1.74,5.4,5.4,0,0,1-3.4,1.15l-.57,0a5.4,5.4,0,0,1-.86-.18A5.71,5.71,0,0,1,91.44,64a6.1,6.1,0,0,1-.73-1.61l0-.13a6.62,6.62,0,0,1-.18-1,7,7,0,0,1,0-1v-.1a7.88,7.88,0,0,1,.22-1.44,8.67,8.67,0,0,1,2.81-4.48,9.37,9.37,0,0,1,2.74-1.61c.28-.11.55-.2.82-.28l.51-.14a10.13,10.13,0,0,1,1.27-.23,5.09,5.09,0,0,1,1.26,0l.2,0A4.12,4.12,0,0,0,97,56s0,.09,0,.13a6.58,6.58,0,0,1,2.11.81,4.77,4.77,0,0,1,1.39,1.28l.08.12a4.73,4.73,0,0,1,.6,1.28,5.73,5.73,0,0,1,.23,1.45c0,.07,0,.13,0,.2A5.36,5.36,0,0,1,100.89,63.69Z",
    transform: "translate(0 0)",
    fill: "#e60000"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#9c303c45-27b5-4ea0-859f-37628ed2402e)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.06
  }, /*#__PURE__*/React.createElement("rect", {
    x: 85,
    y: 118,
    width: 22,
    height: 16,
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "85.63 118.5 81 114.38 81 96",
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "85.63 133.38 81 137.5 81 155.88",
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "106.5 118.5 111 114.38 111 96",
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "106.5 133.38 111 137.5 111 155.88",
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "85.63 126 77.13 126 64.13 113",
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.25,138.88",
    transform: "translate(0 0)",
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.13,126",
    transform: "translate(0 0)",
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "106.5 126 115 126 128 113",
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.88,138.88",
    transform: "translate(0 0)",
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115,126",
    transform: "translate(0 0)",
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 96,
    y1: 133.63,
    x2: 96,
    y2: 155.88,
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 96,
    y1: 96.12,
    x2: 96,
    y2: 118.38,
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }))), /*#__PURE__*/React.createElement("rect", {
    x: 66,
    y: 96,
    width: 60,
    height: 60,
    rx: 16,
    ry: 16,
    fill: "none",
    stroke: "#f4f4f4",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 66,
    y: 96,
    width: 60,
    height: 60,
    rx: 16,
    ry: 16,
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 2,
    opacity: 0.06
  }), /*#__PURE__*/React.createElement("rect", {
    x: 66,
    y: 96,
    width: 60,
    height: 60,
    rx: 16,
    ry: 16,
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 2,
    opacity: 0.06
  }))))))))))))))))))))))))));
}

var _default = ic_sim;
exports.default = _default;